import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OpportunityShowMore = (props) => {
    return (_jsx("a", Object.assign({ className: "opportunity-show-more" }, props, { children: _jsxs("h3", { children: ["Show", _jsx("br", {}), " more", _jsx("br", {}), " items"] }) })));
};
export default OpportunityShowMore;
